import React from 'react';
import { Tooltip } from '@mui/material';

import {
  LoadIndicatorContainer,
  LoadIndicatorLabel,
  LoadIndicatorReloadTrigger,
  LoadIndicatorProgress,
  LoadIndicatorProgressContainer,
  LoadIndicatorProgressInfo,
  LoadIndicatorProgressWrapper,
} from './style';
import MappedLabel from '../../../../common/components/MappedLabel/MappedLabel';

function LoadIndicatorComponent(props) {
  const { totalCount = 1, loadedCount = 0, isLoading = false, isLoaded = false, reload } = props;
  const progress = (loadedCount * 100) / totalCount;

  return (
    <LoadIndicatorContainer>
      <LoadIndicatorProgressWrapper>
        <LoadIndicatorLabel>
          {isLoading ? (
            <MappedLabel reserve="Number of Active devices displayed.">dashboard/map/loadingIndicator/loadingLabel</MappedLabel>
          ) : (
            <MappedLabel reserve="Number of Active devices displayed.">dashboard/map/loadingIndicator/loadedLabel</MappedLabel>
          )}
        </LoadIndicatorLabel>
        <LoadIndicatorProgressContainer>
          <LoadIndicatorProgress style={{ width: `${progress}%` }} />
          <LoadIndicatorProgressInfo>
            {loadedCount} / {totalCount}
          </LoadIndicatorProgressInfo>
        </LoadIndicatorProgressContainer>
      </LoadIndicatorProgressWrapper>
      {!isLoading && isLoaded && (
        <Tooltip title="Reload">
          <LoadIndicatorReloadTrigger onClick={reload} />
        </Tooltip>
      )}
    </LoadIndicatorContainer>
  );
}

export default LoadIndicatorComponent;
